import React from "react";
import Button from "../../shared/button";
import styles from "./styles.css";
import CarImage from "./images/approved-car.png";
import Check from "./images/check.svg";
import PropTypes from "prop-types";

const ZeroDepositeFinanceCardRevamp = ({
    onClickPreApproval
}) => {
    return (
        <div styleName={"styles.wrapper"}>
            <img src={CarImage} />
            <p styleName={"styles.description"}>Now, finance your car at</p>
            <p styleName={"styles.zeroDeposit"}>Zero deposit</p>
            <div styleName={"styles.bottomBorder"}>&nbsp;</div>
            <div styleName={"styles.stepsContainer"}>
                <p styleName={"styles.steps"}><img src={Check} />See lenders you are eligible for</p>
                <p styleName={"styles.steps"}><img src={Check} />Know your borrowing capacity</p>
                <p styleName={"styles.steps"}><img src={Check} />See your potential interest rates</p>
            </div>
            <Button text="Get pre-approval" onClick={onClickPreApproval}/>
        </div>
    );
};

ZeroDepositeFinanceCardRevamp.propTypes = {
    onClickPreApproval: PropTypes.func
};

export default ZeroDepositeFinanceCardRevamp;
